var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.283 7c-9.327 0-16.716 7.343-16.716 16.344 0 9.002 7.51 16.345 16.716 16.345 9.206 0 16.716-7.343 16.716-16.345.12-9-7.51-16.344-16.716-16.344Zm0 22.385c-3.392 0-6.299-2.724-6.299-6.04 0-3.317 2.786-6.041 6.299-6.041 3.512 0 6.298 2.724 6.298 6.04a6.243 6.243 0 0 1-6.298 6.04ZM13.567 11.856v23.806H7.63L0 11.856h13.567Z",
    fill: "#8B3FFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.fe18ac067b8b8741fd647154ae2e64e7.svg";
export { ForwardRef as ReactComponent };